export const SocialData=[
    {
        platform:"Instagram",
        link:"https://www.instagram.com/codingeggs/",
        icon:require('../Assets/instagram1.png'),
    },
    {
        platform:"Github",
        link:"https://github.com/Dhruvasth",
        icon:require('../Assets/github.png'),
    },
    {
        platform:"Twitter",
        link:"https://twitter.com/codingeggs",
        icon:require('../Assets/twitter.png'),
    },
    {
        platform:"Dribble",
        link:"https://dribbble.com/Dhruvasth",
        icon:require('../Assets/dribble.png'),
    },
    {
        platform:"Linkedin",
        link:"https://www.linkedin.com/in/dhruv-asth/",
        icon:require('../Assets/linkedin.png'),
    },
]